/**
 * Google Analytics 4 Metrics Utility
 * Centralizes all event tracking logic for Guiar Arquitectura.
 */

const GA_MEASUREMENT_ID = window.GA_MEASUREMENT_ID; // Fuente única de verdad desde index.html

export const GuiarMetrics = {
    /**
     * Track a page view
     * @param {string} path - The path of the page (e.g. '/', '/#/politica')
     * @param {string} title - The title of the page
     */
    trackPageView: (path, title) => {
        if (typeof window.gtag === 'function') {
            window.gtag('config', GA_MEASUREMENT_ID, {
                page_path: path,
                page_title: title
            });
            console.log(`[Metrics] PageView: ${path} (${title})`);
        }
    },

    /**
     * Track a custom event
     * @param {string} action - The action name
     * @param {object} params - Additional event parameters
     */
    trackEvent: (action, params = {}) => {
        if (typeof window.gtag === 'function') {
            window.gtag('event', action, params);
            console.log(`[Metrics] Event: ${action}`, params);
        }
    },

    // Specific shorthand methods
    trackWhatsAppClick: (location) => {
        GuiarMetrics.trackEvent('whatsapp_click', {
            location: location, // e.g. 'contact_form', 'floating_icon'
            event_category: 'conversion',
            event_label: 'WhatsApp Contact'
        });
    },

    trackFormSubmission: (formName) => {
        GuiarMetrics.trackEvent('form_submission', {
            form_id: formName,
            event_category: 'engagement'
        });
    },

    trackPolicyAcceptance: () => {
        GuiarMetrics.trackEvent('policy_accepted', {
            event_category: 'compliance'
        });
    },

    trackPolicyView: (source) => {
        GuiarMetrics.trackEvent('policy_view', {
            source: source, // e.g. 'footer', 'banner', 'contact_form'
            event_category: 'engagement'
        });
    }
};
